import styled, { css } from 'styled-components';
import { ThemeProps } from '@/styles/global';

interface InputProps {
  isError: boolean;
}

export const Container = styled.div`
  background: ${(props: ThemeProps) => props.theme.limeGreenColor};
  padding: 1.5rem;
  border-radius: 0.25rem;
  margin: 4rem 0;
  @media (max-width: 768px) {
    margin: 2.5rem 0;
    padding: 1rem;
  }
`;

export const Title = styled.p`
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.75rem;
  margin: 0 0 1.5rem 0;
  display: flex;
  align-items: center;
  svg {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 1rem;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  font-weigth: 300;
  color: ${(props: ThemeProps) => props.theme.blackColor};
  margin: 0 0 1.5rem 0;
  line-height: 1.5rem;
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  button {
    height: auto;
    margin-left: 1rem;
    max-width: 8.75rem;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    button {
      height: 3rem;
      margin: 1.25rem 0 0;
      max-width: none;
    }
  }
`;

export const Input = styled.input`
  outline: none;
  border: none;
  height: 3rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  font-family: Ubuntu;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${(props: ThemeProps) => props.theme.darkGrayColor};
  ${(props: InputProps & ThemeProps) =>
    props.isError &&
    css`
      border: 0.0625rem solid red;
      &::-webkit-input-placeholder {
        color: red;
      }
    `}
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 0.75rem;
  position: absolute;
  bottom: -1rem;
  left: 0.2rem;
  @media (max-width: 768px) {
    position: static;
  }
`;

export const Response = styled.p`
  width: 100%;
  text-align: center;
  grid-area: none !important;
  margin: 1rem 0 !important;
`;
